import { toast } from "react-toastify";

const getStorageFavoriteMaterials = (storageKey: string) => { 
    try {
        let favoriteMaterials = localStorage.getItem(storageKey);
        if (favoriteMaterials) {
          let parsedFavoriteMaterials: number[] = JSON.parse(favoriteMaterials)
          return parsedFavoriteMaterials
        }
      } catch (e: any) {
        toast.error(e.message)
      }
}

const setStorageFavoriteMaterials = (storageKey: string, value: any) =>  { 
    localStorage.setItem(storageKey, JSON.stringify(value))
}

const removeStorageFavoriteMaterials = (materialType: string, idToRemove: number) =>  {
    let favoriteMaterial: number[] | undefined;
    switch (materialType) {
        case 'Discipline':
            favoriteMaterial = getStorageFavoriteMaterials('@favorites_disciplines')
            if (favoriteMaterial) {
                const index = favoriteMaterial.indexOf(idToRemove)
                favoriteMaterial.splice(index, 1)
                setStorageFavoriteMaterials('@favorites_disciplines', favoriteMaterial)
            }
          break;
        case 'Item':
            favoriteMaterial = getStorageFavoriteMaterials('@favorites_items')
            if (favoriteMaterial) {
                const index = favoriteMaterial.indexOf(idToRemove)
                favoriteMaterial.splice(index, 1)
                setStorageFavoriteMaterials('@favorites_items', favoriteMaterial)
            }
          break
        case 'Theme':
            favoriteMaterial = getStorageFavoriteMaterials('@favorites_themes')
            if (favoriteMaterial) {
                const index = favoriteMaterial.indexOf(idToRemove)
                favoriteMaterial.splice(index, 1)
                setStorageFavoriteMaterials('@favorites_themes', favoriteMaterial)
            }
          break
        case 'Media':
            favoriteMaterial = getStorageFavoriteMaterials('@favorites_medias')
            if (favoriteMaterial) {
                const index = favoriteMaterial.indexOf(idToRemove)
                favoriteMaterial.splice(index, 1)
                setStorageFavoriteMaterials('@favorites_medias', favoriteMaterial)
            }
          break
        default:
          break;
      }
}

const bulkStorageFavoriteMaterials = () => { 

  return { 
    disciplines: getStorageFavoriteMaterials('@favorites_disciplines') || [],
    items: (getStorageFavoriteMaterials('@favorites_items') || []).concat(getStorageFavoriteMaterials('@favorites_themes') || []),
    medias: getStorageFavoriteMaterials('@favorites_medias') || []
  }
}

export { 
    getStorageFavoriteMaterials,
    setStorageFavoriteMaterials,
    removeStorageFavoriteMaterials,
    bulkStorageFavoriteMaterials
}